var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brokers-holding-proportion rk-section"},[_c('MoreTitle',{attrs:{"title":"经纪商持股比例"}}),_c('BrokerList',{attrs:{"total":10}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }